// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__dar8o","signatureButtonsRight":"ModalSign_signatureButtonsRight__3OS2t"};